import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Switch, Route } from 'react-router'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import GsdApplication from './GsdApplication'
import GsdFileView from './GsdFileView'
import GsdReturn from './GsdReturn'

const Gsd = () => {
  const { path } = useRouteMatch()

  const [selectedSection, setSelectedSection] = useState('gsd')

  const actionListModule = useSelector(
    getUserModuleActions('compensation-approval', 'compensation', 'gsd')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'compensation-approval',
      'compensation',
      'gsd',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="gsd">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('gsd')
                    }}
                    eventKey="gsd"
                  >
                    GSD Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('gsd-return')
                    }}
                    eventKey="gsd-return"
                  >
                    GSD Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'gsd' ? (
              <>
                {checkPermission('view', actionListModule) && (
                  <GsdApplication />
                )}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <GsdReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <GsdFileView type="view" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <GsdFileView type="file-return" {...props} />}
      />
    </Switch>
  )
}

export default Gsd
